import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as Globe } from "../svg/earth-americas-solid.svg";
import { ReactComponent as Calendar } from "../svg/calendar-regular.svg";
import LikeButton from "./LikeButton";

class Post extends React.Component {
  static propTypes = {
    details: PropTypes.shape({
      image: PropTypes.string.isRequired,
      place: PropTypes.string.isRequired,
      desc: PropTypes.string.isRequired,
      year: PropTypes.number.isRequired
    }),
    index: PropTypes.string.isRequired
  }

  render () {
    const { image, place, desc, year } = this.props.details;

    return (
      <div className="card">
        <img src={image} alt={place} />
        <p><span className="author">Ilze-Bilze:</span> {desc}</p>
        <div className="aside">
          <p>
            <span className="svg"><Globe /></span><span className="place">{place}</span>
            <span className="svg"><Calendar /></span><span className="year">{year}</span>
          </p>
          <LikeButton likePost={this.props.likePost} />
        </div>
      </div>
    );
  }
}

export default Post;